// extracted by mini-css-extract-plugin
export default {"form":"InputForm_form__BGbCy","dark":"InputForm_dark__AbCI0"};